import { useCallback, useEffect, useState } from "react";
import { emitNfe, errorMessage, refreshNfe } from "../services/blingService";

// Estado da NF-e de um pedido + ações de emitir / consultar SEFAZ.
// onChange(fiscal) avisa o pai pra manter o pedido em memória atualizado.
export function useNfe(order, onChange) {
  const [fiscal, setFiscal] = useState(order?.fiscal || null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setFiscal(order?.fiscal || null);
    setError(null);
  }, [order?._id, order?.fiscal]);

  const run = useCallback(
    async (action) => {
      if (!order?._id) return;
      setBusy(true);
      setError(null);
      try {
        const updated = await action(order._id);
        const next = { ...(fiscal || {}), ...(updated || {}) };
        setFiscal(next);
        if (onChange) onChange(next);
      } catch (err) {
        setError(errorMessage(err));
      } finally {
        setBusy(false);
      }
    },
    [order?._id, fiscal, onChange],
  );

  const emit = useCallback(() => run(emitNfe), [run]);
  const refresh = useCallback(() => run(refreshNfe), [run]);

  return { fiscal, busy, error, emit, refresh };
}
